/**
 * HeroSlider: with slick carousel library in mode modules
 * http://kenwheeler.github.io/slick/
 */
(function($) {
  "use strict";

  $(window).ready(function() {
    var CONTAINER_SEL = ".HeroSlider"
    var TOLLENSSLIDER_SEL = ".HeroSlider--Tollens"
    var SLIDER_FORCE_ARROWS = ".HeroSlider--with-arrows"

    var allSliders = $(CONTAINER_SEL)
    if (allSliders.length === 0) return

    var tollensSliders = allSliders.filter(TOLLENSSLIDER_SEL)
    var forceArrowsSliders = allSliders
      .not(tollensSliders)
      .filter(SLIDER_FORCE_ARROWS)
    
    var otherSliders = allSliders
      .not(tollensSliders)
      .not(forceArrowsSliders)

    tollensSliders.each(function() {
      var $this = $(this)
      var $dotsContainer = $('<div class="appenddots"></div>')

      $this.after($dotsContainer)

      $this.slick({
        dots: true,
        appendDots: $dotsContainer,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000
      })
    })

    forceArrowsSliders.each(function() {
      $(this).slick({
        dots: true,
        arrows: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000
      });
    })
    
    otherSliders.each(function() {
      $(this).slick({
        dots: true,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000
      });
    })

  })

})(jQuery);
